.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius);
  font-weight: var(--weight-medium);
  white-space: nowrap;
  transition: background var(--transition-fast), border-color var(--transition-fast),
    color var(--transition-fast), box-shadow var(--transition-fast);
}

.button:disabled {
  opacity: 0.55;
  pointer-events: none;
}

.fullWidth { width: 100%; }

/* ------------------------------------------------------------------ sizes */
.sm {
  padding: var(--space-1) var(--space-3);
  font-size: var(--text-sm);
  min-height: 30px;
}
.md {
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-base);
  min-height: 36px;
}
.lg {
  padding: var(--space-3) var(--space-5);
  font-size: var(--text-md);
  min-height: 44px;
}

/* --------------------------------------------------------------- variants */
.primary {
  background: var(--indigo);
  color: #fff;
  border-color: var(--indigo);
}
.primary:hover:not(:disabled) {
  background: var(--indigo-dark);
  border-color: var(--indigo-dark);
}

.secondary {
  background: var(--bg-elevated);
  color: var(--text);
  border-color: var(--border-strong);
}
.secondary:hover:not(:disabled) {
  background: var(--bg-hover);
  border-color: var(--text-subtle);
}

.ghost {
  background: transparent;
  color: var(--text-muted);
}
.ghost:hover:not(:disabled) {
  background: var(--bg-hover);
  color: var(--text);
}

/*
  Destructive actions are OUTLINED, not filled.

  A solid red button competes with the primary action for attention and invites
  the very click it should discourage. Filling only on hover means the weight
  arrives once the pointer is already committed.
*/
.danger {
  background: transparent;
  color: var(--danger);
  border-color: var(--danger);
}
.danger:hover:not(:disabled) {
  background: var(--danger);
  color: #fff;
}

/* -------------------------------------------------------------- internals */
.icon {
  display: inline-flex;
  align-items: center;
  font-size: 1.1em;
  line-height: 1;
}

.spinner {
  width: 0.9em;
  height: 0.9em;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
